function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.751,
  cy: 21.5469,
  r: 20.75,
  fill: "#DE3B62"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2471 18.0029H15.7911V19.0109H11.4711V21.6989H15.5511V22.7069H11.4711V25.5389H15.7911V26.5469H10.2471V18.0029Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.0006 24.4349H18.6806L17.7686 26.5469H16.5086L20.3126 18.0029H21.3566L25.1726 26.5469H23.9126L23.0006 24.4349ZM22.5806 23.4509L20.8406 19.3829L19.1006 23.4509H22.5806Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.4791 18.0029H30.0311C30.9271 18.0029 31.6231 18.2229 32.1191 18.6629C32.6231 19.0949 32.8751 19.6869 32.8751 20.4389C32.8751 21.1909 32.6191 21.7869 32.1071 22.2269C31.6031 22.6589 30.9111 22.8749 30.0311 22.8749H27.7151V26.5469H26.4791V18.0029ZM29.8871 21.8909C30.4791 21.8909 30.9231 21.7669 31.2191 21.5189C31.5231 21.2709 31.6751 20.9109 31.6751 20.4389C31.6751 19.9749 31.5231 19.6189 31.2191 19.3709C30.9231 19.1229 30.4791 18.9989 29.8871 18.9989H27.7151V21.8909H29.8871Z",
  fill: "white"
});

var SvgEap = function SvgEap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eap.3b5379bc.svg";
export { ForwardRef as ReactComponent };